import { useDebouncedValue } from "@mantine/hooks"
import { PaginationState } from "@tanstack/react-table"
import { DEFAULT_PAGE_SIZE } from "@tfg/ui"
import { useEffect, useMemo, useState } from "react"

import { certifcatefiltersValidationType } from "@tfg/types/schemas/admin"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"

import { CertifcateTypes } from "./CertificateTypes"
import { useCertificateTypeQuery } from "./hook"

export function CertificateTypesWrapper() {
  const [searchCertificateType, setSearchCertificateType] = useState<string>("")
  const [debouncedCertificateType] = useDebouncedValue<string>(
    searchCertificateType,
    600
  )

  const [filterValues, setFilterValues] =
    useState<certifcatefiltersValidationType>({
      category: undefined,
      trigger: undefined,
    })
  const [pageCount, setPageCount] = useState<number>(0)
  const [{ pageIndex, pageSize }, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  })

  const pagination = useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize]
  )

  const fetchDataOptions = {
    pageIndex,
    pageSize,
  }
  const certificatesQuery = useCertificateTypeQuery({
    fetchDataOptions,
    searchCertificateType: debouncedCertificateType,
    filters: filterValues,
  })
  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
  }, [debouncedCertificateType])
  return (
    <DataFetchWrapper query={certificatesQuery}>
      {({ data }) => (
        <CertifcateTypes
          certificates={data}
          pagination={pagination}
          setPagination={setPagination}
          setPageCount={setPageCount}
          pageCount={pageCount}
          setSearchCertificateType={setSearchCertificateType}
          searchCertificateType={searchCertificateType}
          isFetching={certificatesQuery.isFetching}
          filterValues={filterValues}
          setFilterValues={setFilterValues}
        />
      )}
    </DataFetchWrapper>
  )
}
